import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { loginRequest, msalInstance } from '@/config/msal'
import logger from '@/utils/logger'

export function getMsalAccount () {
  const activeAccount = msalInstance.getActiveAccount()
  if (activeAccount) return activeAccount

  const accounts = msalInstance.getAllAccounts()
  if (accounts.length === 0) return null

  msalInstance.setActiveAccount(accounts[0])
  return accounts[0]
}

export async function acquireMsalAccessToken ({ redirectOnInteractionRequired = false } = {}) {
  const account = getMsalAccount()

  if (!account) {
    if (redirectOnInteractionRequired) {
      await msalInstance.loginRedirect(loginRequest).catch((error) => {
        logger.error('MSAL loginRedirect error', error)
      })
    }
    return null
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    })

    return response.accessToken
  } catch (error) {
    if (redirectOnInteractionRequired && error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({
        ...loginRequest,
        account,
      }).catch((redirectError) => {
        logger.error('MSAL acquireTokenRedirect error', redirectError)
      })
      return null
    }

    logger.error('MSAL acquireTokenSilent error', error)
    return null
  }
}
